import { client } from '@/shared/lib/client';

interface UserInfo {
  avatar: string;
  displayName: string;
  mail: string;
  name: string;
  ticket: string;
}

interface ApiResponse {
  status: number;
  data?: UserInfo;
  message?: string;
}

/** 后端旧服务还没迁过来，swagger 里没有，所以手写一下 */
export const getUserInfoByUUID = async (uuid: string): Promise<UserInfo | undefined> => {
  try {
    // client 的响应拦截器已经返回了 response.data，所以 response 就是 ApiResponse
    const response = await client<ApiResponse>({
      url: `/api/auth/sso/user?uuid=${uuid}`,
      method: 'GET',
    });
    // response 已经是 response.data（经过拦截器处理），所以直接返回 response.data
    return response.data;
  } catch (error) {
    console.error('Failed to get user info by UUID:', error);
    return undefined;
  }
};
